export default "__VITE_ASSET__CKmR28MH__"